const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      InkscapeStroke: "none"
    },
    d: "M48.697 15.176h12.25v25.437h-12.25zm0 52.251h12.25v25.436h-12.25z",
    color: "#000",
    fill: "#130754"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      InkscapeStroke: "none"
    },
    d: "M48.697 48.037h12.25v12.001h-12.25z",
    color: "#000",
    fill: "#ffca00"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      InkscapeStroke: "none"
    },
    d: "M29.017 36.087h12.25v84.552h-12.25zM67.97 88.414h12.25v25.436H67.97zm0-52.297h12.25v25.437H67.97z",
    color: "#000",
    fill: "#130754"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      InkscapeStroke: "none"
    },
    d: "M67.97 68.983h12.25v12.001H67.97z",
    color: "#000",
    fill: "#e70488"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      InkscapeStroke: "none"
    },
    d: "M87.238 8.55h12.25v84.552h-12.25z",
    color: "#000",
    fill: "#130754"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPd);
export default __webpack_public_path__ + "static/media/pd.5a48d1677b40ca61e96a08e92fdbb64d.svg";
export { ForwardRef as ReactComponent };